import React from "react";

const ProductCard = ({ productArray }) => {
  return (
    <div className="w-[90%] m-4 mx-auto">
      <div className="flex flex-col lg:flex-row bg-white p-6 lg:p-10 rounded-3xl gap-2 justify-between">
        <div className="w-full lg:w-[20%] flex justify-center items-center lg:justify-start lg:items-start">
          <img
            src={productArray?.logo}
            className="max-h-[40px] lg:max-h-[30px] xl:max-h-[40px]"
            alt="Product Logo"
          />
        </div>

        <div className="border border-black  hidden lg:flex"></div>

        <div className="flex w-full lg:w-[40%] lg:hidden justify-center items-center mt-6 lg:mt-0">
          {productArray?.pic !== null && (
            <img
              src={productArray?.pic}
              className="w-full flex"
              alt="product png"
            />
          )}
        </div>

        <div className="w-full lg:w-[40%] flex flex-col gap-6 mt-6 lg:mt-0">
          <p className="w-full text-center lg:text-start text-xl font-bold my-1">
            {productArray?.title}
          </p>
          <p className="w-full text-center lg:text-start text-xl font-medium my-0">
            {productArray?.descri}
          </p>
          <p className="w-full text-center lg:text-start">
            Status :{" "}
            <label className=" text-green-600 font-semibold my-0">
              {productArray?.status}
            </label>
          </p>
          <div className="w-full flex flex-row items-center justify-center lg:justify-start gap-5">
            <img src="/x.svg" width={15} alt="Icon" />
            <img src="/linkdin.svg" width={20} alt="Icon" />
            <img src="/insta.svg" width={20} alt="Icon" />
            <img src="/fb.svg" width={10} alt="Icon" />
          </div>
          <a
            href={productArray?.siteUrl}
            className="w-full text-center lg:text-start no-underline font-semibold"
          >
            {productArray?.siteUrl}
          </a>
        </div>

        <div className="hidden w-full lg:w-[40%] lg:flex justify-center items-center mt-6 lg:mt-0">
          {productArray?.pic !== null && (
            <img
              src={productArray?.pic}
              className="w-full flex"
              alt="product png"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
